var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipsOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.392,
    height: 91.066,
    viewBox: "0 0 71.392 91.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_80",
    x: 8.113,
    y: 7.892,
    width: 55.068,
    height: 55.029,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_81",
    x: 0,
    y: 0,
    width: 71.392,
    height: 80.032,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_82",
    x: 12.097,
    y: 51.682,
    width: 47.233,
    height: 39.385,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_83",
    x: 20.905,
    y: 29.217,
    width: 43.219,
    height: 37.513,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_84",
    x: 34.3,
    y: 20.655,
    width: 32.803,
    height: 35.846,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80-2",
    "data-name": "Path 80",
    d: "M-604.212-917.329A12.348,12.348,0,0,1-617.124-905.1a12.594,12.594,0,0,1-12.153-12.638,12.625,12.625,0,0,1,12.887-12.383A12.45,12.45,0,0,1-604.212-917.329Z",
    transform: "translate(652.39 953.02)",
    fill: "#fcefea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81-2",
    "data-name": "Path 81",
    d: "M-602.492-928.985a20.608,20.608,0,0,0-19.2-14.343,20.828,20.828,0,0,0-20.126,14.387c-2.942,9.512.616,17.446,7.615,22.808a7.893,7.893,0,0,1,3.546,7.25c-.18,5.387-.047,5.392,5.247,5.388,1.058,0,5.64.007,8.393,0,2.47.646,3.4-.254,3.446-3.253.056-3.393-.568-6.718,3.214-9.181C-602.627-910.962-599.711-920.236-602.492-928.985Zm-8.284,20.588c-3.895,2.768-5.6,5.9-5.092,10.5.1.866.3,1.914-.6,2.281-2.537-.04-7.36-.1-8.288.047-2.916.447-4.1-.48-3.708-3.6.456-3.638-.927-6.473-4.208-8.517a15.575,15.575,0,0,1-5.945-6.634,18.53,18.53,0,0,1,7.065-24.143,18.337,18.337,0,0,1,24.729,5.578C-601.481-925-603.021-913.91-610.776-908.4Z",
    transform: "translate(657.85 958.33)",
    fill: "#fcefea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82-2",
    "data-name": "Path 82",
    d: "M-613.944-856.795c1.883,0,3.775.123,5.644-.033,2.179-.183,3.009.529,2.913,2.814-.186,4.41-2.159,6.492-6.61,6.536-1.287.012-2.575.009-3.863,0-4.8-.031-6.922-2.416-6.742-7.275.059-1.584.637-2.1,2.121-2.056C-618.3-856.749-616.123-856.794-613.944-856.795Zm-.145,7.237c1.833-.1,3.791.413,5.339-1.089a3.354,3.354,0,0,0,1.008-3.243c-.332-1.5-1.621-.714-2.452-.75-2.463-.106-4.938-.123-7.4.007-.891.047-2.329-.84-2.633.85a3.321,3.321,0,0,0,1.777,3.735C-617.067-849.289-615.551-849.648-614.088-849.558Z",
    transform: "translate(649.71 923.54)",
    fill: "#fcefea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83-2",
    "data-name": "Path 83",
    d: "M-606.3-886.942c-.392,0-1.338.162-1.542-.878-.229-1.164.7-1.143,1.517-1.259,3.6-.507,6.9-1.673,9.321-4.583.563-.675,1.209-1.161,1.985-.385.848.847,0,1.483-.48,2.013A14.811,14.811,0,0,1-606.3-886.942Z",
    transform: "translate(643.78 938.66)",
    fill: "#fcefea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Path_84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84-2",
    "data-name": "Path 84",
    d: "M-582.686-906.694c-.574,1.068.436,3.135-1.636,3.736a.906.906,0,0,1-1.013-1.321c.91-1.419-.811-3.906,1.707-4.47C-582.783-908.939-582.576-907.8-582.686-906.694Z",
    transform: "translate(634.76 944.42)",
    fill: "#fcefea"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsOn);
export default __webpack_public_path__ + "static/media/tips-on.beafd0394245fc8c4add688c7177b0eb.svg";
export { ForwardRef as ReactComponent };